/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object, func } from 'prop-types';
import {
    Typography,
    Grid,
    TextField,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { useFormContext } from 'react-hook-form';

const styles = () => ({
    yourInfoText: {
        alignSelf: 'start',
        marginBottom: '12px',
        fontWeight: 700,
        fontSize: '16px !important',
    },
    field: {
        borderRadius: '3px',
        backgroundColor: '#fff',
        '& .mbp-account-MuiFilledInput-root': {
            background: '#FFF',
            border: '1px solid #C4C4C4',
            borderRadius: '3px',
            opacity: '1',
        },
        '& .mbp-account-MuiFilledInput-underline:before, .mbp-account-MuiFilledInput-underline.Mui-error:after, .mbp-account-MuiFilledInput-underline:after, .mbp-account-MuiFilledInput-underline.Mui-focused:after': {
            borderBottom: 'none',
        },
        '& .mbp-account-MuiFilledInput-underline.Mui-error': {
            border: '1px solid red',
        },
        '& .mbp-account-MuiFormLabel-root': {
            color: '#555555',
        },
        '& input': {
            fontSize: '16px !important',
        },
        '& .MuiInputBase-root': {
            height: '56px',
        },
        '& .mbp-account-MuiFormHelperText-root.Mui-error': {
            color: '#FFF',
            backgroundColor: '#ff0000',
            margin: '0px',
            padding: '3px 10px',
            fontSize: '12px',
        },
    },
});

const CelebrationsGuestForm = ({ classes, customer, updateCustomer }) => {
    const methods = useFormContext();
    const { register, formState: { errors } } = methods; // Destructure errors from formState

    return (
        <>
            <Typography variant="h6" className={classes.yourInfoText}>Your Information</Typography>
            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    <TextField
                        label="First"
                        name="firstName"
                        variant="filled"
                        fullWidth
                        className={classes.field}
                        {...register(`customer.firstName`)}
                        error={!!errors.customer?.firstName}
                        helperText={errors.customer?.firstName?.message}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        label="Last"
                        name="lastName"
                        variant="filled"
                        fullWidth
                        className={classes.field}
                        {...register(`customer.lastName`)}
                        error={!!errors.customer?.lastName}
                        helperText={errors.customer?.lastName?.message}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        label="Email"
                        name="email"
                        variant="filled"
                        fullWidth
                        className={classes.field}
                        {...register(`customer.email`)}
                        error={!!errors.customer?.email}
                        helperText={errors.customer?.email?.message}
                    />
                </Grid>
            </Grid>
        </>
    )
};

CelebrationsGuestForm.propTypes = {
    classes: object,
    customer: object,
    updateCustomer: func.isRequired,
};

CelebrationsGuestForm.defaultProps = {
    classes: {},
    customer: {},
};

export default withStyles(styles)(CelebrationsGuestForm);
